import React from 'react';

import { Card, CardContent, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { AutocompleteField, InputSearch } from 'common/components';

const BulkOperationsCard = ({
    countryOptions = [],
    filterData,
    handleOnChangeCountry,
    handleOnChangeSearch,
    isFetchingCountries,
}) => {
    const { t } = useTranslation();

    return (
        <Card sx={{ mb: 2 }}>
            <CardContent>
                <Grid
                    alignItems="end"
                    container
                    justifyContent="flex-end"
                    spacing={2}
                >
                    <Grid size="grow">
                        <InputSearch
                            placeholder={t('Search')}
                            onChange={handleOnChangeSearch}
                            value={filterData?.search}
                        />
                    </Grid>

                    <Grid
                        size={{ lg: 3, md: 9, xs: 18 }}
                        sx={{ order: { md: 2, xs: 3 } }}
                    >
                        <AutocompleteField
                            disabled={isFetchingCountries}
                            label={t('Country')}
                            onChange={handleOnChangeCountry}
                            options={countryOptions}
                            value={filterData?.country}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

BulkOperationsCard.propTypes = {
    countryOptions: PropTypes.array,
    filterData: PropTypes.object,
    handleOnChangeCountry: PropTypes.func,
    handleOnChangeSearch: PropTypes.func,
    isFetchingCountries: PropTypes.bool,
};

export default BulkOperationsCard;
